export default function OwnerInfo({userId}) {
    return (<>owner</>);
}
